import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import type { Session } from "@supabase/supabase-js";
import { SignInGate } from "./components/SignInGate";
import { AppShell } from "./components/AppShell";
import { SignupFunnel } from "./pages/SignupFunnel";
import { SignupFunnelV2 } from "./pages/SignupFunnelV2";
import { DemoFunnel } from "./pages/DemoFunnel";
import { Attributions } from "./pages/Attributions";
import { ChurnLeadingIndicators } from "./pages/ChurnLeadingIndicators";
import { MrrDashboard } from "./pages/MrrDashboard";
import { MrrSandbox } from "./pages/MrrSandbox";
import { LlmUsage } from "./pages/LlmUsage";
import { MarlooWau } from "./pages/MarlooWau";
import { OnboardingBaseline } from "./pages/OnboardingBaseline";
import { EmbeddingComparison } from "./pages/EmbeddingComparison";
import { DocumentQA } from "./pages/DocumentQA";
import { Leads } from "./pages/Leads";
import { PaymentFailures } from "./pages/PaymentFailures";
import { DocumentGeneration } from "./pages/Misc/DocumentGeneration";
import { Home } from "./pages/Home";
import { ROUTES, pathToId, idToPath } from "./routes";

function ShellWithRouter({ session }: { session: Session }) {
  const navigate = useNavigate();
  const location = useLocation();
  const page = pathToId(location.pathname);
  const onNavigate = (id: string) => navigate(idToPath(id));

  return (
    <AppShell session={session} page={page} onNavigate={onNavigate}>
      <Routes>
        <Route path={ROUTES["home"]} element={<Home onNavigate={onNavigate} />} />
        <Route path={ROUTES["signup-funnel"]} element={<SignupFunnel />} />
        <Route path="/signup-funnel-v2" element={<SignupFunnelV2 />} />
        <Route path={ROUTES["demo-funnel"]} element={<DemoFunnel />} />
        <Route path="/demo-funnel-secret" element={<DemoFunnel />} />
        <Route path={ROUTES["attributions"]} element={<Attributions />} />
        <Route path={ROUTES["churn-leading-indicators"]} element={<ChurnLeadingIndicators />} />
        <Route path={ROUTES["mrr-dashboard"]} element={<MrrDashboard />} />
        <Route path={ROUTES["mrr-sandbox"]} element={<MrrSandbox />} />
        <Route path={ROUTES["llm-usage"]} element={<LlmUsage />} />
        <Route path={ROUTES["marloo-wau"]} element={<MarlooWau />} />
        <Route path={ROUTES["onboarding-baseline"]} element={<OnboardingBaseline />} />
        <Route path={ROUTES["embedding-comparison"]} element={<EmbeddingComparison />} />
        <Route path={ROUTES["document-qa"]} element={<DocumentQA />} />
        <Route path={ROUTES["leads"]} element={<Leads />} />
        <Route path={ROUTES["payment-failures"]} element={<PaymentFailures />} />
        <Route path={ROUTES["misc-document-generation"]} element={<DocumentGeneration />} />
        <Route path="*" element={<Home onNavigate={onNavigate} />} />
      </Routes>
    </AppShell>
  );
}

export function App() {
  return (
    <SignInGate>
      {(session) => (
        <BrowserRouter>
          <ShellWithRouter session={session} />
        </BrowserRouter>
      )}
    </SignInGate>
  );
}
